module.exports = __webpack_public_path__ + "static/media/tr-favicon.27e70173.svg";